// extracted by mini-css-extract-plugin
export default {"fade-message":"DailyQuizTutorialDialog_fade-message__r-+8+","hidden":"DailyQuizTutorialDialog_hidden__TWdc5","visible":"DailyQuizTutorialDialog_visible__x+XMx"};